export const release = 'myvoyage@9ac05d22';